import { render, staticRenderFns } from "./InvoiceExpandedRow.vue?vue&type=template&id=1b2bf67a&scoped=true"
import script from "./InvoiceExpandedRow.vue?vue&type=script&lang=js"
export * from "./InvoiceExpandedRow.vue?vue&type=script&lang=js"
import style0 from "./InvoiceExpandedRow.vue?vue&type=style&index=0&id=1b2bf67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2bf67a",
  null
  
)

export default component.exports